module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-34.06ff630d.png";